import type { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

export const completeAifcActionExperience = (
	experienceTracker: ExperienceTrackerAPI,
	experienceName: typeof ExperienceName.AIFC_ALL_DATA_HANDLED | typeof ExperienceName.AIFC_MESSAGE,
	actionClassificationCount: number,
	actionCompleteCount: number,
	isBackendCreationRequest: boolean,
): void => {
	const attributes = {
		isBackendCreationRequest,
		actionClassificationCount,
		actionCompleteCount,
	};

	// Matches our condition for abortGenerateContentChildExperiences elsewhere, for callers that don't fallthrough
	// This gives us an explicit abort rather than a timeout
	if (actionClassificationCount > 0 && actionCompleteCount === 0) {
		experienceTracker.abort({
			name: experienceName,
			reason: 'stream_completed_without_action_complete',
			attributes,
		});
		return;
	}

	if (
		!isBackendCreationRequest || // Not all FE requests provide action_classification, so a single complete is sufficient
		actionClassificationCount === actionCompleteCount
	) {
		experienceTracker.succeed({ name: experienceName, attributes });
	} else {
		experienceTracker.fail({
			name: experienceName,
			attributes,
			error: new Error('Action completion count did not match classifications'),
		});
	}
};
